import { PluginObject } from "vue/types/plugin";

import { api } from "./ApiPlugin";
import { storage } from "@/plugins";
import { Code } from "@/interfaces/interfaces";

export class Authentication {
  constructor() {}

  public async registerUser(
    type: "A" | "B" | "C" | "voter" | "judge",
    data: any
  ): Promise<Code> {
    const { response, error } = await api.userRegistration(type, data);
    if (error) return Code.API_RESPONSE_ERR;
    if (response!.data.fail) {
      if (response!.data.fail === "There is no valid reCAPTCHA token") {
        return Code.RECAPTCHA_TOKEN_INVALID;
      }
      if (
        response!.data.fail ===
        "Please register again as we suspect you are robot."
      ) {
        return Code.SUSPICIOUS_USER;
      }
      if (response!.data.fail.email[0] === "The email already registered") {
        return Code.ALREADY_REGISTERED;
      }
      if (response!.data.fail.name) return Code.INVALID_DATA_ERR;
      return Code.UNKONWN_ERR;
    }
    return Code.SUCCESS;
  }

  public async login(email: string, password: string): Promise<Code> {
    const { response, error } = await api.getUserTokenApi(email, password);

    if (error) return Code.API_RESPONSE_ERR;
    if (response!.data.fail === "0") return Code.VERIFY_EMAIL_ERR;
    if (response!.data.fail === "1") return Code.INVALID_DATA_ERR;
    if (storage.setToken(response!.data.token) === Code.LOCAL_STORAGE_SET_ERR)
      return Code.LOCAL_STORAGE_SET_ERR;
    return Code.SUCCESS;
  }

  public async verifyUser(): Promise<Code | any> {
    const token = storage.getToken();
    if (token === null) return Code.LOCAL_STORAGE_TOKEN_NOT_FOUND;

    const { response, error } = await api.getUserDetailsApi(token);
    if (error) return Code.API_RESPONSE_ERR;
    if (response!.data.status === "Token is Invalid") {
      storage.removeToken();
      return Code.JWT_TOKEN_INVALID;
    }
    if (response!.data.status === "Authorization Token not found")
      return Code.JWT_TOKEN_NOT_PROVIDED;
    return response!.data;
  }

  public logout() {
    storage.removeToken();
  }
}

export const auth = new Authentication();
export const AuthPlugin: PluginObject<any> = {
  install: (vue, options) => {
    vue.prototype.$auth = auth;
  },
};
